module.exports = __webpack_public_path__ + "static/img/report.a34cc29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report.png
// module id = dJA2
// module chunks = 1